import { useColumnsOrganizationGuestUsers } from 'Hooks/useColumnsOrganizationGuestUsers';
import useTranslate from 'Hooks/useTranslate';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import LocalStorage from 'Tools/localStorage';
import UsersTableBase, { UsersTableBaseProps } from './UsersTableBase';

type OrganizationGuestUsersTableProps = Omit<
  UsersTableBaseProps<string>,
  | 'activeColumns'
  | 'onChangeColumns'
  | 'onResetColumns'
  | 'toolbarLeftContent'
  | 'canDeleteUsers'
  | 'canSubscribeUsers'
  | 'canInviteUsers'
  | 'scope'
> & {
  organizationCode: string;
};

function OrganizationGuestUsersTable(
  props: Readonly<OrganizationGuestUsersTableProps>
) {
  const defaultColumns = useColumnsOrganizationGuestUsers();
  const ts = useTranslate();
  const [columns, setColumns] = useState(
    LocalStorage.deserializeColumns(
      defaultColumns,
      LocalStorage.OrganizationGuestUsersColumns ?? []
    )
  );

  const onChangeColumns = (newColumns: any) => {
    setColumns(newColumns);
    LocalStorage.OrganizationGuestUsersColumns = LocalStorage.serializeColumns(
      newColumns
    );
  };

  const onResetColumns = () => {
    LocalStorage.OrganizationGuestUsersColumns = null;
    setColumns(defaultColumns);
  };

  return (
    <>
      <Helmet title={ts('page.organizations.title')} />
      <UsersTableBase
        {...props}
        activeColumns={columns}
        onChangeColumns={onChangeColumns}
        onResetColumns={onResetColumns}
        canDeleteUsers={true}
        canSubscribeUsers={false}
        canInviteUsers={true}
        scope={{ kind: 'organizationGuests', organizationCode: props.organizationCode }}
      />
    </>
  );
}

export default OrganizationGuestUsersTable;
